export default __webpack_public_path__ + "static/media/mouse-click-right.3621a059.svg";